var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProdutos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 4.74996H14.1667C14.1667 2.56496 12.3 0.791626 10 0.791626C7.7 0.791626 5.83333 2.56496 5.83333 4.74996H4.16667C3.25 4.74996 2.5 5.46246 2.5 6.33329V15.8333C2.5 16.7042 3.25 17.4167 4.16667 17.4167H15.8333C16.75 17.4167 17.5 16.7042 17.5 15.8333V6.33329C17.5 5.46246 16.75 4.74996 15.8333 4.74996ZM10 2.37496C11.3833 2.37496 12.5 3.43579 12.5 4.74996H7.5C7.5 3.43579 8.61667 2.37496 10 2.37496ZM15.8333 15.8333H4.16667V6.33329H15.8333V15.8333ZM10 9.49996C8.61667 9.49996 7.5 8.43913 7.5 7.12496H5.83333C5.83333 9.30996 7.7 11.0833 10 11.0833C12.3 11.0833 14.1667 9.30996 14.1667 7.12496H12.5C12.5 8.43913 11.3833 9.49996 10 9.49996Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdutos);
export default __webpack_public_path__ + "static/media/Produtos.4723db3b2ef68a9f25b49f896b59b8e6.svg";
export { ForwardRef as ReactComponent };